module.exports = {
  DefaultLocale: 'en',
  Locales: ['en', 'zh-TW', 'zh-CN', 'ja'],
}
